import * as tslib_1 from "tslib";
import { Component, Ref, Vue } from "vue-property-decorator";
import { getChannellist, changeChannelStatus, saveChannel } from '@/api/exchange';
let ExchangeManage = class ExchangeManage extends Vue {
    constructor() {
        super(...arguments);
        this.channelFilter = {
            searchType: 1,
            keyword: '',
            status: -1,
        };
        this.channelList = [];
        this.channelOptions = [];
        this.isChannelLoading = false;
        this.channelPaginator = {
            pageNo: 1,
            pageSize: 20,
            total: 0,
        };
        this.channelCreator = {
            isVisible: false,
            isLoading: false,
            content: {
                id: '',
                title: '',
                description: '',
            },
            validateRules: {
                title: [
                    {
                        validator: (_, value, cb) => {
                            if (value.trim() === '') {
                                cb(new Error('请输入渠道名称'));
                            }
                            else if (value.length > 20) {
                                cb(new Error('限20字符以内'));
                            }
                            else {
                                cb();
                            }
                        },
                        trigger: 'blur',
                    },
                ],
                description: [{ max: 100, message: '限100字符以内', trigger: 'blur' }],
            },
        };
    }
    created() {
        this.getList();
    }
    getList() {
        let data = {
            searchType: this.channelFilter.searchType,
            keyword: this.channelFilter.keyword,
            isHidden: this.channelFilter.status,
            pageNo: this.channelPaginator.pageNo,
        };
        getChannellist(data).then((res) => {
            if (res.data.status === 200) {
                this.channelList = res.data.data.list || [];
                this.channelPaginator.pageSize = Number(res.data.data.pageSize);
                this.channelPaginator.pageNo = Number(res.data.data.pageNum);
                this.channelPaginator.total = Number(res.data.data.total);
            }
            else {
                // this.$message.error(res.data.msg);
                this.channelList = [];
                this.channelPaginator.pageNo = 1;
                this.channelPaginator.total = 0;
            }
        });
    }
    handleChannelFilter() {
        this.channelPaginator.pageNo = 1;
        this.getList();
    }
    showChannelCreator() {
        this.channelCreator.isVisible = true;
    }
    handleChannelStatusChange(props) {
        changeChannelStatus;
        let msg = `是否${props.isHidden == 1 ? '显示' : '隐藏'}该渠道？`;
        this.$confirm(msg, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(() => {
            let data = {
                id: props.id,
                isHidden: props.isHidden == 1 ? 0 : 1
            };
            let headers = {
                email: localStorage.getItem('email') || '',
            };
            changeChannelStatus(data, headers).then((res) => {
                if (res.data.status == 200) {
                    this.$message({
                        type: 'success',
                        message: '操作成功'
                    });
                    this.getList();
                }
            });
        }).catch(() => {
            this.$message({
                type: 'info',
                message: '已取消'
            });
        });
    }
    handleChannelPageChange(pageNo) {
        this.channelPaginator.pageNo = pageNo;
        this.getList();
    }
    handleChannelSave() {
        if (this.channelCreator.content.title === '') {
            this.$message.error('渠道名称不可为空');
            return;
        }
        let data = {
            channelName: this.channelCreator.content.title,
            channelInfo: this.channelCreator.content.description,
        };
        let headers = {
            email: localStorage.getItem('email') || '',
        };
        saveChannel(data, headers).then((res) => {
            if (res.data.status === 200) {
                this.$message({
                    type: 'success',
                    message: '创建成功'
                });
                this.closeChannelCreator();
                this.getList();
            }
        });
    }
    closeChannelCreator() {
        this.channelCreator.isVisible = false;
        this.channelCreator.isLoading = false;
        this.channelCreator.content = {
            id: '',
            title: '',
            description: '',
        };
    }
};
tslib_1.__decorate([
    Ref()
], ExchangeManage.prototype, "channelCreateForm", void 0);
ExchangeManage = tslib_1.__decorate([
    Component
], ExchangeManage);
export default ExchangeManage;
